import * as moment from 'moment';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Popup from 'reactjs-popup';
import close from "../../../../../assets/close.svg";
import dropdown from "../../../../../assets/dropdown.svg";
import logo1 from "../../../../../assets/table-img.svg";
import logo2 from "../../../../../assets/table-img2.svg";
import { config } from "../../../../../config";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { permissions } from "../../../../../Store/reducers/PermissionsReducer";
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import { BACK_DROP_FALSE, formatPhoneNumber, maskingToPlainNumber, numberWithCommas } from "../../../../../Util/helper";
import RateCard from "../../../../../Util/RateCard/RateCard";
import AddEditEmployeeModalContent from "../Employees/Modals/AddEditEmployeeModal";
import "./User.css";
const columns = [
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Name</div>,
    selector: () => 'first_name',
    className: 'left-align',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : 'N/A'}{row.registered_through === 'C' ? <img src={logo1} alt='icon' /> : <img className="icon" src={logo2} alt='icon' />}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Gender</div>,
    selector: () => 'gender',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.gender ? row.gender : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Email</div>,
    selector: () => 'email',
    minWidth: '160px !important',
    sortable: 'true',
    style: {
      padding: '0',
      whiteSpace: 'pre-wrap !important'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.email ? row.email : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Primary Phone</div>,
    selector: () => 'cell_phone',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.cell_phone ? formatPhoneNumber(row.cell_phone) : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Secondary Phone</div>,
    selector: () => 'secondary_phone',
    minWidth: '136px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.secondary_phone ? formatPhoneNumber(row.secondary_phone) : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Shirt Size</div>,
    selector: () => 'shirt_size',
    minWidth: '98px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.shirt_size ? row.shirt_size : 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Last Logged In</div>,
    selector: () => 'last_logged_in_at',
    minWidth: '98px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.last_logged_in_at ? moment(row.last_logged_in_at).format('M/DD/YYYY hh:mm A') : 'N/A'}</div>)
  },
];

const columnsZip = [
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Zip</div>,
    selector: () => 'zip',
    className: 'left-align',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.zip || 'N/A'}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Total</div>,
    selector: () => 'total',
    className: 'left-align',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.total}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Male</div>,
    selector: () => 'male',
    className: 'left-align',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.male}</div>)
  },
  {
    name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Female</div>,
    selector: () => 'female',
    className: 'left-align',
    minWidth: '130px !important',
    sortable: 'true',
    style: {
      padding: '0'
    },
    cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.female}</div>)
  },
]

const userType = 'user';

function User() {
  const [messageDropEnable, setMessageDropEnable] = useState(false);
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [userDetail, setUserDetail] = useState({
    first_name: '',
    last_name: '',
    cell_phone: '',
    email: '',
    direction: 'desc',
    sort_column: '',
    page: 1,
    limit: 50,
  });
  const [totalPage, setTotalPage] = useState(0);
  const [totalMaleFemale, setTotalMaleFemale] = useState({
    totalUsers: 0,
    male: 0,
    female: 0,
    malePercentage: 0.00,
    femalePercentage: 0.00
  });
  const [loader, setLoader] = useState(true);
  const selector = useSelector(permissions);
  const [showZipcodeAnalysis, setShowZipcodeAnalysis] = useState(false);
  const [zipcodeData, setZipcodeData] = useState([]);
  const [zipcodeTableData, setZipcodeTableData] = useState([]);
  const defaultZipcodeFilter = {
    sort_column: 'total',
    direction: 'desc',
    page: 1,
    limit: 10,
    search: '',
  }
  const [zipcodeFilter, setZipcodeFilter] = useState(defaultZipcodeFilter);

  const enableMesgDrop = () => {
    setMessageDropEnable(!messageDropEnable);
  }

  const closeModal = () => {
    setOpen(false);
  }

  const getUsers = () => {
    setLoader(true);
    axiosApi.get(`${config.apiUrl}/users/${userType}`, {
      params: userDetail
    })
      .then((response) => {
        setUserData(response.data.data);
        setTotalPage(response.data.total);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  }

  const getTotalUsers = () => {
    axiosApi.get(`${config.apiUrl}/users/count`)
      .then((response) => {
        if (response.data &&
          response.data.data &&
          response.data.data.length) {
          const data = response.data.data[0];
          const usersSum = {
            totalUsers: data.total ? numberWithCommas(Number(data.total)) : 0,
            male: data.male ? numberWithCommas(Number(data.male)) : 0,
            female: data.female ? numberWithCommas(Number(data.female)) : 0,
          }
          const total = Number(data.total) || 1;
          usersSum['malePercentage'] = ((Number(data.male) / total) * 100).toFixed(0);
          usersSum['femalePercentage'] = ((Number(data.female) / total) * 100).toFixed(0);
          setTotalMaleFemale(usersSum);
        }
      })
      .catch((err) => {

      });
  }

  const getTotalUsersByZip = () => {
    axiosApi.get(`${config.apiUrl}/users/count-by-zip`)
      .then((response) => {
        setZipcodeData(response?.data?.data);
        setZipcodeFilter(defaultZipcodeFilter);
        filteredZipcodeData(defaultZipcodeFilter, response?.data?.data);
      })
  }

  useEffect(() => {
    getTotalUsers();
    getTotalUsersByZip();
  }, []);

  useEffect(() => {
    getUsers();
    //eslint-disable-next-line
  }, [userDetail.page, userDetail.limit, userDetail.direction, userDetail.sort_column])

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.name === 'cell_phone' ? maskingToPlainNumber(e.target.value) : String(e.target.value).trim(),
      })
    }
    setUserDetail(stateFunc);
  }
  const handleSearch = (e) => {
    e.preventDefault();
    setUserDetail(() => ({
      ...userDetail,
      'page': 1,
      'direction': '',
      'sort_column': '',
    }))
    getUsers();
  }

  const filteredZipcodeData = (resFilter, resData) => {
    const filter = resFilter || zipcodeFilter;
    const data = resData || [...(zipcodeData || [])];

    if (!data?.length) return;

    let updatedData = [...data].sort((a, b) => {
      if (filter.direction === 'asc') {
        return (a[filter.sort_column] || 0) - (b[filter.sort_column] || 0);
      } else {
        return (b[filter.sort_column] || 0) - (a[filter.sort_column] || 0);
      }
    });

    updatedData = updatedData.slice((filter.page - 1) * filter.limit, filter.page * filter.limit);
    setZipcodeTableData(updatedData);
  };

  const handleZipcodeChange = (e) => {
    const filter = { ...zipcodeFilter };

    if (e.target.name === 'sort_column') {
      filter.sort_column = e.target.value;
      filter.direction = e.target.direction;
      filter.page = 1;
    }

    if (e.target.name === 'page') {
      filter.page = e.target.value;
    }

    if (e.target.name === 'limit') {
      filter.limit = Number(e.target.value);
      filter.page = 1;
    }

    filteredZipcodeData(filter);
    setZipcodeFilter(filter);
  }


  const showZipcodeAnalysisModal = () => {
    filteredZipcodeData(defaultZipcodeFilter);
    setZipcodeFilter(defaultZipcodeFilter);
    setShowZipcodeAnalysis(true);
  }

  return (
    <>
      <div className={messageDropEnable ? 'overlay' : ''} onClick={() => setMessageDropEnable(false)}></div>
      <div className="user-wrapper">
        <div className="header-blk">
          <h2>Overview</h2>
          <div class="wrap-actions">
            <button className="btn btn-primary" onClick={showZipcodeAnalysisModal}>Zipcode Analysis</button>
            {
              selector.some(permission => ['mass_email', 'mass_text'].includes(permission)) &&
              <div className="dropdown-blk">
                <div className="dropdown-header" onClick={enableMesgDrop}>
                  <img src={dropdown} alt='user-logo' />
                  <span>Message Users</span>
                </div>
                <ul className={`${messageDropEnable ? 'active' : ''} dropdown-menu`}>
                  {
                    selector.includes('mass_email') &&
                    <li>
                      <Link to="/admin/send-email">Send Email</Link>
                    </li>
                  }
                  {
                    selector.includes('mass_text') &&
                    <li>
                      <Link to="/admin/send-sms">Send SMS</Link>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
        <div className="cards-wrapper">
          <div className="cards-blk">
            <RateCard text='Total Users' value={totalMaleFemale.totalUsers} />
            <RateCard text='Male Users' value={`${totalMaleFemale.male} (${totalMaleFemale.malePercentage}%)`} />
            <RateCard text='Female Users' value={`${totalMaleFemale.female} (${totalMaleFemale.femalePercentage}%)`} />
          </div>
        </div>
        <div className="search-blk search-blk-user">
          <h2>Search</h2>
          <form onSubmit={handleSearch}>
            <div className="input-field">
              <label htmlFor="first_name">First Name</label>
              <input type="text" id="first_name" name="first_name" onChange={handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="last_name">Last Name</label>
              <input type="text" id="last_name" name="last_name" onChange={handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="email">Email Address</label>
              <input type="text" id="email" name="email" onChange={handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="contact">Phone Number</label>
              <input id="cellPhone" name="cell_phone" onChange={handleChange} />
            </div>
            <button type='submit'>Search</button>
          </form>
        </div>
      </div>
      <div className="table-wrapper">
        <div className="heading-blk">
          <div className="left">
            <h2>Results</h2>
            <p>Select a user to view details.</p>
          </div>
        </div>
        <div className="dataTable">
          <DataTableComponent key="table-admin-users"
            loading={loader}
            type={'user'}
            data={userData}
            columns={columns}
            onFilterChange={handleChange}
            totalPage={totalPage}
            limit={userDetail.limit}
            refresh={() => getUsers()} />
        </div>
      </div>
      <Popup className="usersEdit-popup" open={open} closeOnDocumentClick={BACK_DROP_FALSE} onClose={closeModal}>
        <AddEditEmployeeModalContent closeModal={closeModal} />
      </Popup>
      <Popup className="zip-code-modal" open={showZipcodeAnalysis} closeOnDocumentClick={BACK_DROP_FALSE} onClose={() => setShowZipcodeAnalysis(false)}>
        <div className="modal">
          <div className="modal-header">
            <h2>Zipcode Analysis</h2>
            <span className="close" onClick={() => setShowZipcodeAnalysis(false)}>
              <img src={close} alt='close-icon' />
            </span>
          </div>
          <div className="add-adminModal dataTable modal-table-scroll" >
            <DataTableComponent key="table-admin-zipcode"
              data={zipcodeTableData}
              columns={columnsZip}
              onFilterChange={handleZipcodeChange}
              totalPage={zipcodeData?.length || 0}
              limit={zipcodeFilter.limit}
              disableRowClicked={true}
            />
          </div>
        </div>
      </Popup>
    </>
  );
}

export default withRouter(User);
